
































































































import Vue from 'vue';
import { ToastProgrammatic as Toast } from 'buefy';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { CreateDocumentRepoDTO } from '@/utils/types/documentRepo/documentRepo';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'DocumentRepoInput',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {},
  data() {
    return {
      url: 'https://github.com/TiredFalcon/test-latex-2.git',
      mainTexFileName: 'main.tex',
      isPrivate: true,
      username: 'AronFiechter',
      token: '',
      examples: [{
        url: 'https://gitlab.reveal.si.usi.ch/research/emadpres-icse2020.git',
        mainTexFileName: 'main.tex',
      }, {
        url: 'https://gitlab.reveal.si.usi.ch/research/fengcai-icpc2020.git',
        mainTexFileName: 'main.tex',
      }, {
      //   // FAILING (nested tabular)
      //   url: 'https://gitlab.reveal.si.usi.ch/research/bin-icpc2019.git',
      //   mainTexFileName: '',
      // }, {
        url: 'https://gitlab.reveal.si.usi.ch/research/msr2019-stackoverflow-reuse.git',
        mainTexFileName: 'icpc2019.tex',
      }, {
        url: 'https://gitlab.reveal.si.usi.ch/research/fengcai-icpc2019.git',
        mainTexFileName: 'main.tex',
      }, {
        url: 'https://gitlab.reveal.si.usi.ch/research/bin-saner2019-era.git',
        mainTexFileName: 'saner2019-era.tex',
      }, {
      //   // FAILING (nested tabular)
      //   url: 'https://gitlab.reveal.si.usi.ch/research/bin-saner19.git',
      //   mainTexFileName: 'saner2019.tex',
      // }, {
        url: 'https://gitlab.reveal.si.usi.ch/research/emadpres-adana-tse.git',
        mainTexFileName: 'main.tex',
      }, {
        // MOSTLY FAILING (nested tabular)
        url: 'https://gitlab.reveal.si.usi.ch/research/bin-ase2018.git',
        mainTexFileName: 'ase2018.tex',
      }, {
        url: 'https://gitlab.reveal.si.usi.ch/research/emadpres-icse2019.git',
        mainTexFileName: 'main.tex',
      }],
      selectedExample: undefined as { url: string; mainTexFileName: string } | undefined,
    };
  },
  watch: {
    selectedExample(newSelection) {
      this.url = newSelection.url;
      this.mainTexFileName = newSelection.mainTexFileName;
    },
  },
  methods: {
    ...mapActions('documentRepo', ['postDocumentRepo']),
    callPostDocumentRepo() {
      const {
        url,
        mainTexFileName,
        isPrivate,
        username,
        token,
      } = this;
      const payload = {
        url,
        mainTexFileName,
        isPrivate,
        ...(isPrivate ? { username, token } : {}),
      } as CreateDocumentRepoDTO;

      return this.postDocumentRepo(payload)
        .then(() => {
          Toast.open({
            message: `"${url}" analysis initiated successfully!`,
            type: 'is-success',
          });
          (this.$parent as Vue & { close: () => undefined }).close();
        })
        .catch((error) => {
          Toast.open({
            message: `${error} &mdash; occurred when initializing "${url}" analysis`,
            type: 'is-danger',
          });
        });
    },
    postAll(): void {
      this.examples
        .reduce(async (prev, ex) => {
          await prev;
          this.url = ex.url;
          this.mainTexFileName = ex.mainTexFileName;
          return this.callPostDocumentRepo();
        }, Promise.resolve());
    },
  },
});
